var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import * as React from 'react';
import { connect } from 'react-redux';
import Spinner from '@cimpress/react-components/lib/shapes/Spinner';
import PriceExplorerGrid from './components/PriceExplorerGrid';
import './styles/PricingGrid.css';
import Config from './config/config';
import Logger from './logger/logger';
import isEqual from 'lodash/isEqual';
import { setToken } from './services/token';
import { loadPricingGridData, clearState, setDeliveryLocations, setSkuProductionTime, setShippingConfiguration, setLogger, setFulfillmentLocations, getSelectedTabConfiguration } from './actions/PricingGridComponentAction';
import { saveLoggedSku } from './actions/PriceExplorerGridAction';
import CssLoader from '@cimpress/react-components/lib/CssLoader';
import { ingestData } from './services/cimbaIngestion';
import { CONSTANTS } from './utils/constants'; // eslint-disable-next-line react/prefer-stateless-function

var PricingGridComponent =
/** @class */
function (_super) {
  __extends(PricingGridComponent, _super);

  function PricingGridComponent(props) {
    var _this = _super.call(this, props) || this;

    _this.componentDidCatch = function (error, info) {
      _this.logger.logError({
        message: 'Error occurred in PricingGridComponent Error Boundary',
        error: {
          errorInfo: error,
          info: info
        }
      }, 'pricingGrid');
    };

    _this.loadInitialData = function () {
      var _a = _this.props,
          skuData = _a.skuData,
          onGetAccessToken = _a.onGetAccessToken,
          isProduction = _a.isProduction,
          priceMode = _a.priceMode,
          shippingCostPreview = _a.shippingCostPreview,
          productPricePreviews = _a.productPricePreviews,
          widthOfQuantity = _a.widthOfQuantity,
          widthOfGrid = _a.widthOfGrid,
          parentService = _a.parentService,
          showToolBar = _a.showToolBar,
          toolBarIcons = _a.toolBarIcons,
          initialShippingConfiguration = _a.initialShippingConfiguration,
          showCompetitivePricing = _a.showCompetitivePricing,
          competitors = _a.competitors,
          productPriceContractsInfoV2 = _a.productPriceContractsInfoV2,
          showTabbedView = _a.showTabbedView,
          selectedTab = _a.selectedTab,
          grossMarginSelections = _a.grossMarginSelections,
          saveTabInfo = _a.saveTabInfo;
      var productPriceContractsInfo = _this.props.productPriceContractsInfo;
      var skuList = Object.keys(skuData);
      var isSingleSkuEnvironment = skuList.length < 2 || skuList.length === 2 && (showCompetitivePricing || skuList[1] === 'competitorProducts');

      if (productPriceContractsInfo || productPriceContractsInfoV2) {
        if (productPriceContractsInfo) {
          productPriceContractsInfo = {
            version: 'v1',
            contracts: productPriceContractsInfo
          };
        }

        if (productPriceContractsInfoV2) {
          var resourceId_1 = productPriceContractsInfoV2.resourceId,
              priceConfigurations = productPriceContractsInfoV2.priceConfigurations;
          priceConfigurations.forEach(function (configuration) {
            configuration.resourceId = resourceId_1;
          });
          productPriceContractsInfo = {
            version: 'v2',
            priceConfigurations: priceConfigurations
          };
        }
      }

      var normalizedSkuData = JSON.parse(JSON.stringify(skuData)); // if scope is missing use product as scope

      Object.values(normalizedSkuData).forEach(function (response) {
        var _a;

        (_a = response.resolvedAttributes) === null || _a === void 0 ? void 0 : _a.forEach(function (rowAttributes) {
          rowAttributes.values.forEach(function (columnAttributes) {
            var state = columnAttributes.state,
                attributes = columnAttributes.attributes;

            if (state === CONSTANTS.FULLYRESOLVED) {
              attributes.forEach(function (attribute) {
                if (!attribute.class) {
                  attribute.class = 'product';
                }
              });
            }
          });
        });
      });

      _this.props.loadPricingGridData({
        skuData: normalizedSkuData,
        onGetAccessToken: onGetAccessToken,
        isProduction: isProduction,
        priceMode: priceMode,
        shippingCostPreview: shippingCostPreview,
        productPricePreviews: productPricePreviews,
        widthOfQuantity: widthOfQuantity,
        widthOfGrid: widthOfGrid,
        initialized: true,
        logger: _this.logger,
        isSingleSkuEnvironment: isSingleSkuEnvironment,
        parentService: parentService,
        showToolBar: showToolBar,
        toolBarIcons: toolBarIcons,
        showCompetitivePricing: showCompetitivePricing,
        competitors: competitors,
        productPriceContractsInfo: productPriceContractsInfo,
        showTabbedView: showTabbedView,
        selectedTab: selectedTab,
        grossMarginSelections: grossMarginSelections,
        saveTabInfo: saveTabInfo
      }); // save required props in redux state


      if (isSingleSkuEnvironment) {
        _this.props.getSelectedTabConfiguration(selectedTab);

        _this.props.setFulfillmentLocations(normalizedSkuData);

        _this.props.setDeliveryLocations(normalizedSkuData);

        _this.props.setSkuProductionTime(normalizedSkuData);

        _this.props.setShippingConfiguration(initialShippingConfiguration);
      }
    };

    _this.pushToCimba = function (skuData) {
      var loggedSKU = _this.props.priceExplorerGrid.loggedSKU;

      if (skuData && Object.keys(skuData).length) {
        var sku = Object.keys(skuData)[0];

        if (sku !== loggedSKU) {
          _this.props.saveLoggedSku(sku);

          ingestData({
            feature: null
          }, sku);
        }
      }
    };

    Config.setEndpointsByEnv(_this.props.isProduction);
    _this.componentName = 'PricingGrid';
    _this.logger = new Logger(props.onGetAccessToken);

    _this.logger.logInfo('Pricing Grid in use', _this.componentName);

    _this.props.setLogger(_this.logger);

    setToken(props.onGetAccessToken);
    return _this;
  }

  PricingGridComponent.prototype.componentDidMount = function () {
    this.pushToCimba(this.props.skuData); // To push logs from marketplace catalog

    if (this.props.skuData) {
      this.loadInitialData();
    }
  };

  PricingGridComponent.prototype.componentWillUnmount = function () {
    this.props.clearState();
  };

  PricingGridComponent.prototype.componentDidUpdate = function (prevProps, prevState) {
    var _a = this.props,
        skuData = _a.skuData,
        priceMode = _a.priceMode,
        pricingGrid = _a.pricingGrid,
        showCompetitivePricing = _a.showCompetitivePricing,
        grossMarginSelections = _a.grossMarginSelections,
        selectedTab = _a.selectedTab;
    var prevSkus = prevProps.skuData ? Object.keys(prevProps.skuData) : [];
    var currentSkus = skuData ? Object.keys(skuData) : [];

    if (!isEqual(prevSkus, currentSkus)) {
      ingestData({
        feature: null
      }, currentSkus[0]);
    }

    if (!isEqual(prevProps.skuData, skuData) || !isEqual(prevSkus, currentSkus) || !isEqual(prevProps.priceMode, priceMode) || prevProps.showCompetitivePricing !== showCompetitivePricing || JSON.stringify(prevProps.grossMarginSelections) !== JSON.stringify(grossMarginSelections) || prevProps.selectedTab !== selectedTab) {
      this.loadInitialData();
    }

    if (pricingGrid && prevProps.pricingGrid && !isEqual(pricingGrid.shippingConfiguration, prevProps.pricingGrid.shippingConfiguration)) {
      if (this.props.onChangeShippingConfiguration) {
        this.props.onChangeShippingConfiguration(pricingGrid.shippingConfiguration); // callback to send changes in shipping config
      }
    }
  };

  PricingGridComponent.prototype.render = function () {
    var _a = this.props.pricingGrid,
        initialized = _a.initialized,
        widthOfGrid = _a.widthOfGrid;

    if (!initialized) {
      return React.createElement(Spinner, {
        className: "flex-center"
      });
    }

    var gridComponent = React.createElement(PriceExplorerGrid, null);
    return React.createElement(CssLoader, null, React.createElement("div", {
      style: {
        width: widthOfGrid
      }
    }, React.createElement("div", null, gridComponent)));
  };

  PricingGridComponent.defaultProps = {
    priceMode: 'total',
    widthOfGrid: '850px'
  };
  return PricingGridComponent;
}(React.Component);

function mapStateToProps(state) {
  return {
    pricingGrid: state.pricingGrid,
    priceExplorerGrid: state.priceExplorerGrid
  };
}

var mapDispatchToProps = {
  loadPricingGridData: loadPricingGridData,
  setDeliveryLocations: setDeliveryLocations,
  setSkuProductionTime: setSkuProductionTime,
  setShippingConfiguration: setShippingConfiguration,
  setFulfillmentLocations: setFulfillmentLocations,
  setLogger: setLogger,
  clearState: clearState,
  saveLoggedSku: saveLoggedSku,
  getSelectedTabConfiguration: getSelectedTabConfiguration
};
var connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(PricingGridComponent);